import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog } from '@mui/material';

import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { IConfirmationModalProps } from 'v3/shared/components/Modal/ConfirmationModal/types';
import { HeadlineLarge } from 'v3/shared/typography/HeadlineLarge';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';

import {
  confirmationDialogPaperPropsStyle,
  StyledButtonContainer,
  StyledDialogContent,
  StyledIconButton,
  StyledImage,
} from '../SellerCodeModal/styles';

export const ConfirmationModal: React.FC<IConfirmationModalProps> = ({ modal, onClose, onConfirm }) => {
  return (
    <Dialog
      open={modal.active}
      onClose={onClose}
      PaperProps={{
        sx: confirmationDialogPaperPropsStyle,
      }}
    >
      <StyledIconButton onClick={onClose}>
        <CloseIcon />
      </StyledIconButton>
      <StyledDialogContent>
        <StyledImage src={modal.image} />
        <HeadlineLarge>{modal.title}</HeadlineLarge>
        <SubtitleLarge>{modal.subtitle}</SubtitleLarge>
        <StyledButtonContainer>
          <TextButton
            data-testid="text-button-cancel"
            size="small"
            $outline
            text={modal.cancelButtonText}
            handleClick={onClose}
          />
          <FlexButton
            data-testis="flex-button-confirm-button-text"
            size="small"
            text={modal.confirmButtonText}
            handleClick={onConfirm}
          />
        </StyledButtonContainer>
      </StyledDialogContent>
    </Dialog>
  );
};
